import { getValueFromName } from "../lib/helper";
import { AnyObject, BaseEntity, dateTimeIOSString } from "./base.model";
import { Company } from "./company.model";
import { CompanyStore } from "./company.store.model";
import { Survey } from "./survey.model";
import { Coupon } from "./coupon.model";

// uid could be email, mobile or device
export interface SurveyEventSubmit {
  status: SurveyEventStatusEnum;
  surveyEventId: string;
  companyId: string;
  id: string;
  uid: string;
  email?: string;
  name?: string;
  device?: string;
  viewedAt?: dateTimeIOSString;
  answeredAt?: dateTimeIOSString;
  sentAt?: dateTimeIOSString;
  answers?: AnyObject;
  deviceId?: string;
  completionTime?: number;
  ip?: string;
  invalid?: boolean;
  invalidReason?: string;
  coupon?: Coupon;
  storeId?: string;
}

interface SurveyOption {
  primaryColor?: string;
}

interface SurveyEventConfiguration {
  deviceIdTime?: number;
  ipTime?: number;
  completionTime?: number;
  durationTime?: number;
}

export interface SurveyEvent extends BaseEntity {
  id: string;
  surveyId: string;
  companyId: string;
  options?: SurveyOption;
  survey?: Survey;
  company?: Company;
  stores?: CompanyStore[];
  store?: CompanyStore; // this comes from client selection
  configuration?: SurveyEventConfiguration;
  emailSubject?: string;
  emailContent?: string;
}

export enum SurveyEventStatusEnum {
  "draft" = "draft",
  "sent" = "sent",
  "viewed" = "viewed",
  "answered" = "answered",
}

export enum SurveyEventEmailTemplateEnum {
  "send" = "send",
  "resend" = "resend",
}

export function formatSurveyContent(val: string, surveyEvent: SurveyEvent) {
  const pattern = /\{\{([^{}]+)\}\}/g;
  return (val || "").replace(
    pattern,
    (_, key) => getValueFromName(surveyEvent, key) || "",
  );
}
